import { IAutoMapper } from "../interfaces";

export const mapProjectNodeModel = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "ProjectNodeModel")
    .forMember("projectId", o => o.projectId)
    .forMember("projectName", o => o.projectName)
    .forMember("templateType", o => o.templateType);
};
